import { toast } from '@side/pantry';
import { useCallback, useState } from 'react';
import { coreApi } from '$api-clients';
import type { CoreRequest } from '$api-clients/hooks';

// TODO: Remove Omit override once CORE-15951 is merged and deployed — accountId and accountType will be required in the schema
type OauthRequestQueryParams = Omit<
  CoreRequest<'/oauth/request'>['Query'],
  'accountId' | 'accountType'
> & {
  accountId: string;
  accountType: 'user' | 'team';
  errorMessage?: string;
};

export const useGetOauthRequestUrl = ({
  errorMessage,
  provider,
  returnPath,
  accountId,
  accountType,
}: OauthRequestQueryParams) => {
  const [loading, setLoading] = useState(false);

  const getOauthRequestUrl = useCallback(async (): Promise<
    string | undefined
  > => {
    setLoading(true);

    try {
      const response = await coreApi.GET('/oauth/request', {
        params: {
          query: {
            provider,
            returnPath,
            accountId,
            accountType,
          },
        },
      });
      if (response.error !== undefined) {
        throw new Error(
          typeof response.error === 'string'
            ? response.error
            : response.error.message,
        );
      }
      if (!response.data.requestUrl) {
        throw new Error('No request URL returned from the OAuth request');
      }
      return response.data.requestUrl;
    } catch {
      toast('error', errorMessage ?? 'Failed to get OAuth request URL');
      return undefined;
    } finally {
      setLoading(false);
    }
  }, [provider, returnPath, accountId, accountType, errorMessage, setLoading]);

  return { getOauthRequestUrl, loading };
};
